module.exports = __webpack_public_path__ + "static/media/Alike.ec59b410.woff2";